import React from 'react'; 
import {Row, Col, Label, Button, FormGroup,
         FormControl, ControlLabel} from 'react-bootstrap';
import {injectIntl} from 'react-intl';
import DefaultForm from './DefaultForm';
import {BMC_BLOCKS} from '../common_components/bmc/bmc_constants';
import {inject, observer} from 'mobx-react';
import CostStructureForm from './CostStructureForm';
import ActivityInformationForm from './ActivityInformationForm';
import {LEAN_BLOCKS} from './constants';
import LeanForm from './LeanForm';


@inject("rootStore") @observer
export default class BlockForm extends React.Component{

  render(){
    const block = this.props.rootStore.igBusinessStore.currentBlock;
    let form = (<DefaultForm />);
    switch(block){
      case BMC_BLOCKS.KEY_ACTIVITIES:
        form = <ActivityInformationForm />;
        break;
      case LEAN_BLOCKS.MEASURE:
      case LEAN_BLOCKS.BUILD:
      case LEAN_BLOCKS.LEARN:
        form = <LeanForm />
    }
    return(form);
  }
  
}